import { Injectable } from "@angular/core";
import {
  BILLING_TYPE,
  EXPORT_CHARGE_ITEM_TYPE,
  IAggregatedChargeItemsInfo,
  IChargeItemsInfo,
  IDataSourceBackendParam,
  IFilter,
  IReference,
} from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { BillingApiService } from "./billing-api.service";

@Injectable({
  providedIn: "root",
})
export class BillingService {
  constructor(private invoiceApi: BillingApiService) {}

  public findInvoices(
    params: IDataSourceBackendParam,
    patientId?: string,
    aggregated?: boolean
  ): Observable<IChargeItemsInfo[] | IAggregatedChargeItemsInfo[]> {
    params.filters = this.formatFilters(params.filters);
    return this.invoiceApi.findInvoices(params, patientId, aggregated);
  }

  public getInvoicesCount(services: string[], filters?: IFilter[], patientId?: string): Observable<{ count: number }> {
    return this.invoiceApi.getInvoicesCount(services, this.formatFilters(filters), patientId);
  }

  private formatFilters(filters: IFilter[]): IFilter[] {
    // Placeholder pour adapter les filtres si nécessaire
    return filters;
  }

  public exportChargeItems(
    identifiers: string[],
    format: EXPORT_CHARGE_ITEM_TYPE,
    serviceIds: string[],
    columnOrders?: string[],
    isAggregatedView = false
  ): Observable<Blob> {
    return this.invoiceApi.exportChargeItems(identifiers, format, serviceIds, columnOrders, isAggregatedView);
  }
  public sendChargeItems(identifiers: string[]): Observable<unknown> {
    return this.invoiceApi.sendChargeItems(identifiers);
  }

  public updateChargeItemStatus(identifiers: string[], newStatus: BILLING_TYPE): Observable<unknown> {
    return this.invoiceApi.updateChargeItemStatus(identifiers, newStatus);
  }

  public getAvailableStatusTransitions(status: BILLING_TYPE): BILLING_TYPE[] {
    switch (status) {
      case BILLING_TYPE.BILLABLE:
        return [BILLING_TYPE.NOT_BILLABLE, BILLING_TYPE.PLANNED];
      case BILLING_TYPE.NOT_BILLABLE:
        /*if (chargeItem.prescription.pricingPeriodicity?.frequency > 1) {
          return [BILLING_TYPE.ACCUMULATED];
        } not working yet */
        return [BILLING_TYPE.BILLABLE];
      case BILLING_TYPE.ACCUMULATED:
        // return [BILLING_TYPE.BILLABLE, BILLING_TYPE.NOT_BILLABLE]; not implemented yet
        return [];
      default:
        return [];
    }
  }

  public addChargeItemComment(chargeItemId: string, comment: string): Observable<{ text: string; author?: IReference; time?: string }> {
    return this.invoiceApi.addChargeItemComment(chargeItemId, comment);
  }

  public recalculateAdherences(identifiers: string[]): Observable<unknown> {
    return this.invoiceApi.recalculateAdherences(identifiers);
  }
}
